import Config from "config/config";


interface ImageProps {
    [key: string]: any; 
    onDragStart ?: (event: React.DragEvent<HTMLImageElement>) => void
}

export default function CustomImage(props : ImageProps){
    if(!props.src) return <></> ;
    
    const imgProps = {...props};
    if(!/^http.*$/ig.test(imgProps.src) && !/base64/ig.test(imgProps.src)) imgProps.src = Config.routePrefix + imgProps.src ;
    imgProps.loading = 'lazy';
    return (
        <img {...imgProps}  />
    )
}